import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PERSON_USES_BOOK_FEATURE_KEY,
  PersonUsesBookState,
  personUsesBookAdapter,
} from './person-uses-book.reducer';
import { selectBookSelectModalScopeId } from '../scope/scope.selectors';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';
import { compareDesc, parseISO } from 'date-fns';

export const selectPersonUsesBookState =
  createFeatureSelector<PersonUsesBookState>(PERSON_USES_BOOK_FEATURE_KEY);

const { selectAll } = personUsesBookAdapter.getSelectors();

export const selectAllPersonUsesBooks = createSelector(
  selectPersonUsesBookState,
  (state: PersonUsesBookState) => selectAll(state),
);

export const selectBookSelectPersonUsesBook = createSelector(
  selectAllPersonUsesBooks,
  selectBookSelectModalScopeId,
  (personUsesBooks, scopeId) =>
    personUsesBooks.find(
      (personUsesBook) => personUsesBook.scopeId === scopeId,
    ),
);

export const selectPersonUsesBookByScopeId = (scopeId: string) =>
  createSelector(selectAllPersonUsesBooks, (personUsesBooks) =>
    personUsesBooks.find(
      (personUsesBook) => personUsesBook.scopeId === scopeId,
    ),
  );

export const selectLatestCallState = createSelector(
  selectPersonUsesBookState,
  (state: PersonUsesBookState) => state.latestCallState,
);

export const selectLatestLoading = createSelector(
  selectLatestCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectLatestLoaded = createSelector(
  selectLatestCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectLatestError = createSelector(
  selectLatestCallState,
  (callState: CallState) => getError(callState),
);

export const selectLatestPersonUsesBooks = createSelector(
  selectAllPersonUsesBooks,
  (personUsesBooks) =>
    personUsesBooks
      .sort((a, b) => {
        return compareDesc(parseISO(a.lastUsedAt), parseISO(b.lastUsedAt));
      })
      .slice(0, 3),
);
